//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const ForcePassCaptcha: FeatureFlag = {"Id":"ForcePassCaptcha","Label":"(QA) FORCE ALL CAPTCHA CHECKS TO PASS","Impact":"For QA. CAPTCHA checks always passes. For automated testing to work on forms with CAPTCHAs","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":6};
